// Tanzania destination — packages DERIVED from the single source
// (data/tanzaniaSafariData.js, relocated out of the old TanzaniaPackages.js component).
import { safariPackages } from '../tanzaniaSafariData';
import { canonicalPackage } from './adapt';

const packages = safariPackages.map((p) =>
  canonicalPackage({
    id: p.tourCode,
    name: p.tourName || p.name,
    countryName: 'Tanzania',
    duration: p.duration,
    priceFrom: null, // raw Tanzania packages carry no rates yet
    description: p.description || (p.highlights || []).slice(0, 2).join(' · '),
    highlights: p.highlights || [],
    regions: p.locations || p.destinations || [],
    coverImage: p.coverImage,
    itinerary: p.itinerary,
  })
);

export const tanzaniaDestination = {
  key: 'tanzania',
  name: 'Tanzania',
  emoji: '🇹🇿',
  tagline: 'Serengeti, Ngorongoro, and unparalleled wildlife experiences',
  signature: 'Ngorongoro Crater',
  heroImage:
    'https://images.unsplash.com/photo-1619494139903-f34bc7095e0f?w=1920&h=1080&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDJ8fHRhbnphbmlhfGVufDB8fDB8fHww',
  highlights: ['Serengeti', 'Ngorongoro Crater', 'Mount Kilimanjaro', 'Tarangire'],
  bestTime: 'June-October (Dry season), December-March (Calving season)',
  wildlife: ['Big Five', 'Great Migration', 'Tree-climbing lions', 'Black rhino'],
  climate: 'Tropical with distinct wet and dry seasons',
  currency: 'Tanzanian Shilling (TZS)',
  language: 'English, Swahili',
  mapCenter: [-6.369, 34.8888],
  mapMarkers: [
    { position: [-2.3333, 34.8333], name: 'Serengeti' },
    { position: [-3.1667, 35.5833], name: 'Ngorongoro Crater' },
    { position: [-3.0674, 37.3556], name: 'Mount Kilimanjaro' },
    { position: [-6.1659, 39.2026], name: 'Zanzibar' },
  ],
  packages,
};
